// Keep this version in sync with the API. A change requires fresh uploader consent.
export const BLUEPRINT_POLICY_VERSION = '2026-10-13';
export const COMMUNITY_LICENSE_URL =
  'https://creativecommons.org/publicdomain/zero/1.0/';
export const COMMUNITY_WARNING =
  'Do not upload things you paid for. Those artists work very hard to create these tools and deserve to be paid for them.';
export const COMMUNITY_ENFORCEMENT =
  'If we confirm that you redistributed purchased or unauthorized content, we will blacklist your account from community sharing. You can appeal a decision.';
const configuredEmail = String(
  import.meta.env.VITE_COPYRIGHT_CONTACT_EMAIL || ''
).trim();
export const COPYRIGHT_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
  configuredEmail
)
  ? configuredEmail
  : 'support@studiovaultbeta.com';
export const COPYRIGHT_CONTACT_URL = `mailto:${COPYRIGHT_EMAIL}?subject=Studio%20Vault%20copyright%20notice`;
